<template>
<div class="alinha-templete">
    <HeadDetailsGama  :buttonsAccredited="true" v-on:salve="openModal" :btnNewEmpreendimento="true" :titleHead="'Detalhes Empreendimentos'"></HeadDetailsGama>

    <Tables class="Table-enterprise" ref="tableGrids"
      :columns="head"
      :showSearch="false"
      :showPrint="false"
      :showDownload="false"
      :showFullscreen="false"
       style="font-family:'Segoe UI'"
      v-on:Load="getAllEnterpriseByAccredited"
    >
      <tr  v-for="data in  credenciadaEmpre" :key="data.id">
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.empreendimento == null ? 'N/D' : data.empreendimento.nome == null ? 'N/D' : data.empreendimento.nome" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.empreendimento == null ? 'N/D' : data.empreendimento.endereco == null ? 'N/D' : data.empreendimento.endereco" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.empreendimento == null ? 'N/D' : data.empreendimento.cidade == null ? 'N/D' : data.empreendimento.cidade.nome" />
          <TableColumn :newState="true" :colorStatus="data.empreendimento.colorStatus" :descriptionNewStatus="['Em construção','Finalizado','Lançamento','Futuro',''][data.empreendimento.status]"  :status="1" :value="data.empreendimento.status"/>
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.empreendimento.tamanho" />
          <TableColumn :IsActionsButtons="true" v-on:Delete="deleteEnterpriseAccredited(data)" :status="1" :HasChange = "false"/>
      </tr>
    </Tables>
    <Toaddenterprise v-on:getAllEnterpriseByAccredited="getAllEnterpriseByAccredited" :id="id" ref="AbrirModal"/>
</div>

</template>

<script>
import Tableenterprise from './tableenterprise'
export default Tableenterprise

</script>

<style scoped>
.alinha-templete{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  row-gap: 1.3rem;
}
.title-enterprise{
  margin-top: 2%;
  text-align: left;
  font: normal normal 600 18px/24px Segoe UI;
  letter-spacing: 0.27px;
  color: #008148;
  opacity: 1;
}

.Ttitle-enterprise{
  width: 50%;
  height: 50%;
}

 @media screen and (max-width: 1600px) {
    .Table-Info{
    width: 108%;
    height: 50%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/tableenterprise/tableenterprise.vue